import { AppState } from '@chegg-wt/core/state/types'
import { createSelector } from 'reselect'
import {
  CITATION_LIST_NAME_LOWER_PLURAL,
  CITATION_LIST_NAME_LOWER_SINGLE,
} from '@chegg-wt/core/constants/citations'
import { projectsByIndexSelector } from '../projects/selectors'

export const modalSelector = (state: AppState) => state.modals
export const modalTypeSelector = (state: AppState) => state.modals.modalType
export const modalDataSelector = (state: AppState) => state.modals.data
export const modalSyntheticRouteNameSelector = (state: AppState) =>
  state.modals.syntheticRouteName

// TODO: Replace with meLinks/ids from data instead of using indexes of arrays
export const indexFromModalDataSelector = createSelector(
  [modalDataSelector],
  (modalData) => modalData.index
)

export const idsFromModalDataSelector = createSelector(
  [modalDataSelector],
  (modalData) => modalData.ids
)

export const moveProjectModalTitleSelector = createSelector(
  [projectsByIndexSelector],
  (projects): string =>
    projects.length > 1
      ? `Move ${projects.length} ${CITATION_LIST_NAME_LOWER_PLURAL}`
      : `Move ${CITATION_LIST_NAME_LOWER_SINGLE}`
)
export const moveProjectModalDescriptionSelector = createSelector(
  [projectsByIndexSelector],
  (projects): string =>
    projects.length > 1
      ? `Where do you want to move these ${CITATION_LIST_NAME_LOWER_PLURAL}?`
      : `Where do you want to move this ${CITATION_LIST_NAME_LOWER_SINGLE}?`
)
